import { BaseElement } from '@webtides/element-js';

class TrackingElement extends BaseElement {
    constructor(options = {}) {
        super(options);
        this.$trackingTarget = null;
        this.$trackingTargets = [];
        // TODO: not used
        // this.$trackingElements = {};
    }

    connected() {
        this.$trackingTarget = this.getTrackingTarget();
        this.$trackingTargets = this.getTrackingTargets();
        // TODO: not used
        //this.registerTrackingElements();
    }

    properties() {
        return {
            target: '',
        };
    }

    getTrackingTarget() {
        return this.target ? document.querySelector(this.target) : null;
    }

    getTrackingTargets() {
        return this.target ? document.querySelectorAll(this.target) : [];
    }

    // TODO: do we *really* need this?
    // registerTrackingElements() {
    //     if (!this.$trackingTarget) return;
    //
    //     const trackingNodeList = this.$trackingTarget.querySelectorAll('[data-tracking-id]');
    //     const trackingMap = {};
    //
    //     Array.from(trackingNodeList).forEach(trackingNode => {
    //         const trackingId = trackingNode.getAttribute('data-tracking-id');
    //         trackingMap[trackingId] = trackingNode;
    //     });
    //
    //     this.$trackingElements = trackingMap;
    // }

    findTrackingContext() {
        const trackingContext = this.closest('[data-tracking-context]');
        let context = '';

        if (trackingContext) {
            context = trackingContext.getAttribute('data-tracking-context');
        }

        return context;
    }
}

export default TrackingElement;
